import React from "react";
import Button from "../../components/Button";
import Icon from "../../components/Icon";
import ImageWrapper from "../../components/ImageWrapper";
import children1 from "../../assets/img/children1.jpg";
import collageTeen from "../../assets/img/collage-teen.png";
import ContactForm from "../../sections/ContactForm";
import Doctor from "../../sections/Doctor";

export default function ElevenFifteen() {
  return (
    <>
      <div className="bg-children w-full h-[70vh] bg-cover bg-center flex items-center justify-center">
        <h1 className="text-4xl lg:text-5xl text-white text-center font-extrabold">
          Ортодонтия за тийнейджъри
        </h1>
      </div>
      <div className="page__width my-32 gap-2 flex flex-col items-center justify-center">
        <div className="flex items-center gap-1">
          <div className="bg-brand w-16 rounded-full h-[6px]"></div>
          <div className="bg-brand w-8 rounded-full h-[6px]"></div>
          <div className="bg-brand w-2 rounded-full h-[6px]"></div>
        </div>
        <h2 className="text-3xl font-extrabold text-center text-heading">
          Ортодонтско Лечение в тийнейджърска възраст
        </h2>
        <p className="text-body text-lg w-3/5 text-center">
          Вторият пик на растеж при децата започва между 11-12 г възраст при
          момичетата и 13-14г при момчетата, което винаги е индивидуално.В този
          период е изключително важно да се използва растежът и да се постигнат
          най-вече корекция на зъбно–челюстни несъответствия, а не само
          подреждане на зъбите.
        </p>
      </div>

      <div className="page__width mt-20 flex flex-col-reverse justify-between lg:flex-row-reverse items-center gap-8">
        <div className="w-full lg:w-1/2">
          <ImageWrapper src={children1} className="w-full rounded-lg" />
        </div>
        <div className="w-full lg:w-2/5 flex gap-2 flex-col items-start">
          <div className="flex items-center gap-1">
            <div className="bg-brand w-16 rounded-full h-[6px]"></div>
            <div className="bg-brand w-8 rounded-full h-[6px]"></div>
            <div className="bg-brand w-2 rounded-full h-[6px]"></div>
          </div>
          <h2 className="text-3xl font-extrabold text-heading">
            Фактори за Успех на Лечението
          </h2>
          <p className="text-base text-body font-normal">
            Oртодонтското лечение в тази възраст направлява растежа на
            челюстите, коригира челюстните несъответствия, влияе върху
            подредбата на зъбите, обикновено продължава между 24-30 месеца. Това
            е лечение с брекети и екстраорални апарати -при необходимост.
          </p>
          <p className="text-base text-body font-normal">
            Продължителността на лечението зависи от няколко фактора:сериозност
            на проблема, спазване на посещенията по график и съдействие от
            страна на пациента.
          </p>

          <Button type="cta-border" href="/contact">
            Запазете час още сега!
          </Button>
        </div>
      </div>


      {/* <div className="page__width mt-20 flex flex-col-reverse justify-between lg:flex-row items-center gap-8">
                <div className="w-full lg:w-1/2">
                    <ImageWrapper
                        src={children2}
                        className="w-full"
                    />
                </div>
                <div className="w-full lg:w-2/5 flex gap-2 flex-col items-start">
                    <div className="flex items-center gap-1">
                        <div className="bg-brand w-16 rounded-full h-[6px]"></div>
                        <div className="bg-brand w-8 rounded-full h-[6px]"></div>
                        <div className="bg-brand w-2 rounded-full h-[6px]"></div>
                    </div>
                    <h2 className="text-3xl font-extrabold text-heading">
                        Продължителност и Фактори на Лечението
                    </h2>
                    <p className="text-base text-body font-normal">
                        Ортодонтското лечение обикновено продължава 24-30
                        месеца, но продължителността зависи от сериозността на
                        проблема и сътрудничеството на пациента. Лечението
                        коригира челюстните несъответствия и подрежда зъбите, за
                        да осигури трайни резултати.
                    </p>
                    <Button
                        type="cta-border"
                        href="#">
                        Запазете час още сега!
                    </Button>
                </div>
            </div> */}

      <div className="page__width mt-20 flex flex-col justify-center items-center">
                <h2 className="text-3xl font-extrabold text-heading my-8">Преди и След</h2>
        <ImageWrapper src={collageTeen} className="w-full lg:w-2/3 rounded-xl" />
      </div>
      <Doctor name="daliya" />

      <div className="page__width flex flex-col items-center justify-center my-20">
        <div className="flex items-center gap-1">
          <div className="bg-brand w-16 rounded-full h-[6px]"></div>
          <div className="bg-brand w-8 rounded-full h-[6px]"></div>
          <div className="bg-brand w-2 rounded-full h-[6px]"></div>
        </div>
        <h2 className="text-3xl font-extrabold text-heading my-8">
          Свържете се с нас
        </h2>
        <div className="flex flex-col lg:flex-row w-full items-center justify-between gap-4">
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="email" className="w-10 h-10" />
            <a
              href="mailto:tomov.dentalclinic@gmail.com"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              tomov.dentalclinic
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="phone" className="w-10 h-10" />
            <a
              href="tel:088 528 5757"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              088 528 5757
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="location" className="w-10 h-10" />
            <a
              href="https://maps.app.goo.gl/GWjbmeVQZosEFJNv9"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              ul.Opalchenska 94
            </a>
          </div>
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2931.8174914281817!2d23.313118100000004!3d42.707585099999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40aa85ed09dbf16d%3A0xcfff98bb12f6872!2sTomov%20Dental%20Clinic!5e0!3m2!1sen!2sbg!4v1718888234195!5m2!1sen!2sbg"
          className="w-full mt-8 rounded-xl"
          height="600"
          style={{ border: 0 }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <div className="w-[90%] lg:w-1/2 mx-auto">
        <ContactForm />
      </div>
      <div className="page__width cta my-20 bg-cover bg-right lg:bg-center flex flex-col lg:items-start justify-center bg-cta-dark lg:bg-cta py-16 px-8 items-center text-center lg:text-start lg:px-16 lg:py-24 rounded-xl">
        <h2 className="text-3xl lg:text-4xl w-full lg:w-1/2 mb-6 text-white font-extrabold">
          Блестящата усмивка е на една ръка разстояние
        </h2>
        <Button href="#">Свържи се с нас</Button>
      </div>
    </>
  );
}
